import React, { useEffect, useMemo, useState } from "react";
import CurrencyInput from "react-currency-input-field";

import { Modal, Table } from "react-bootstrap";
import { URLS } from "../urls";
import DatePicker from "react-datetime";
import { branch_id, checkDates, checkDays } from "../../utils";
import Select from "react-select";
import { toast } from "react-toastify";
import moment from "moment";
import currency from "currency.js";
import { converArrayToObject } from "../../utils";
import { DisapprovedCheckIcon } from "../icons";
// import { upperFirst } from "lodash";

export function AddOvertimeModal({
  setShowAddOvertimeModal,
  refetch,
  setSelected,
  openApproval,
}) {
  const [state, setState] = useState({
    overtimeDate: new Date(),
    hours: 0,
    employeeId: "",
    description: "",
    allowanceId: "",
    branch_id,
    total: 0,
  });
  const [loading, setLoading] = useState(false);
  const [employees, setEmployees] = useState([]);
  const [mapEmployees, setMapEmployees] = useState([]);
  const [allowance, setAllowance] = useState([]);
  const [chechedAllowance, setChechedAllowance] = useState([]);
  const [contracts, setcontracts] = useState([]);
  const [jobs, setJobs] = useState([]);
  const [addedArray, setAddedArray] = useState([]);
  const [overTimeAmount, setOverTimeAmount] = useState(0);
  const [useCustom, setUseCustom] = useState(false);
  // const [useAmount, setUseAmount] = useState(0);
  const [holdIt, setHoldIt] = useState({
    overtimeDate: new Date(),
    description: "",
    allowanceId: "",
    amount: 0,
    name: "",
    job: "",
    tittle: "",
    overtimeDateTo: new Date(),
    days: 0,
  });

  const getEmployees = () => {
    return new Promise(async (resolve, reject) => {
      const token = "dummy token";
      fetch(`${URLS.backendEmployees}/get/${branch_id}`, {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Token ${token}`,
        },
      })
        .then((res) => res.json())
        .then((result) => {
          const emp = result.employees.map((em) => ({
            ...em,
            label: `${
              em.personalInfo.name.first ? em.personalInfo.name.first : ""
            } ${
              em.personalInfo.name.middle ? em.personalInfo.name.middle : ""
            } ${em.personalInfo.name.last ? em.personalInfo.name.last : ""}`,
            value: em.userId,
          }));
          setEmployees(result.employees);
          setMapEmployees(emp);
          resolve();
        })
        .catch((err) => {
          console.log(err);
          reject();
        });
    });
  };

  const getAllowances = () => {
    return new Promise(async (resolve, reject) => {
      const token = "dummy token";
      fetch(`${URLS.backendAllowance}/branch-earned/${branch_id}`, {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Token ${token}`,
        },
      })
        .then((res) => res.json())
        .then((result) => {
          setAllowance(result?.allowance);
          resolve();
        })
        .catch((err) => {
          console.log(err);
          reject();
        });
    });
  };

  const getContracts = () => {
    return new Promise(async (resolve, reject) => {
      const token = "dummy token";
      fetch(`${URLS.backendContracts}/get`, {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Token ${token}`,
        },
      })
        .then((res) => res.json())
        .then((result) => {
          setcontracts(result?.contracts);
          resolve();
        })
        .catch((err) => {
          console.log(err);
          reject();
        });
    });
  };

  const getJobs = () => {
    return new Promise(async (resolve, reject) => {
      const token = "dummy token";
      fetch(`${URLS.mainSiteBackend}/job`, {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Token ${token}`,
        },
      })
        .then((res) => res.json())
        .then((result) => {
          const MappedJobs = result?.data?.jobs?.map((el) => ({
            label: el?.title,
            value: el?.jobNumber,
          }));
          setJobs(MappedJobs);
          resolve();
        })
        .catch((err) => {
          console.log(err);
          reject();
        });
    });
  };

  useEffect(() => {
    const setUp = async () => {
      setLoading(true);
      try {
        await Promise.all([
          getEmployees(),
          getAllowances(),
          getContracts(),
          getJobs(),
        ]);
      } catch (err) {
        console.log(err);
      } finally {
        setLoading(false);
      }
    };
    setUp();
    return () => {};
  }, []);

  useEffect(() => {
    const total = addedArray?.reduce(
      (c, p) => parseFloat(c) + parseFloat(p.amount),
      0
    );
    const hours = addedArray?.reduce(
      (c, p) => parseFloat(c) + parseFloat(p.days),
      0
    );

    setState((st) => ({ ...st, hours, total }));
  }, [addedArray]);

  const allowanceForSelectedUser = useMemo(() => {
    return chechedAllowance
      .filter((el) => el)
      .map((el) => ({ ...el, label: el.name, value: el._id }));
  }, [chechedAllowance]);

  const getAllowanceForUser = (id) => {
    let usersAllowance = [];
    let maturity = true;
    let duration = true;

    // Find the selected user
    const user = employees.find((el) => el?.userId === id);
    const jobInfo = user?.jobInfo;

    // get the contract name from the selected user
    const usedcontract = contracts.find(
      (el) => el._id === jobInfo?.contractType
    )?.contractName;

    user.usedcontract = usedcontract !== undefined ? usedcontract : "";

    allowance.forEach((el) => {
      // Check the maturity period of the allowance
      if (el["paymentPeriod"] === "CustomPeriod") {
        const getTime = el["maturityPeriod"]?.split(" ");
        maturity = getTime
          ? checkDates(jobInfo["startDate"], getTime[0], getTime[1])
          : false;
      }

      // Check for Duration Period of the allowance
      if (el["durationType"] === "CustomDuration") {
        duration = checkDays(
          el["dateRange"]["startDate"],
          el["dateRange"]["endDate"]
        );
      }

      if (maturity && duration) {
        if (
          el["DeductType"] === "Employees" &&
          el["selectedDeducts"]?.includes(user["userId"])
        ) {
          usersAllowance.push(el);
        } else if (
          el["DeductType"] === "Job Grade" &&
          el["selectedDeducts"]?.includes(jobInfo["grade"]?._id)
        ) {
          usersAllowance.push(el);
        } else if (
          el["DeductType"] === "Contract" &&
          el["selectedDeducts"]?.includes(jobInfo["contractType"])
        ) {
          usersAllowance.push(el);
        } else if (el["DeductType"] === "All") {
          usersAllowance.push(el);
        } else if (
          el["DeductType"] === "Permanent" &&
          user["usedcontract"] === undefined
        ) {
          usersAllowance.push(el);
        }
      }
    });
    setChechedAllowance(usersAllowance);
    //console.log(usersAllowance);
  };

  const saveToAllowance = async () => {
    try {
      const token = "dummy token";
      const res = await fetch(`${URLS.backendOvertime}/add-new`, {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Token ${token}`,
        },
        body: JSON.stringify({ overtime: { state, addedArray } }),
      });

      const result = await res.json();

      if (result.success) {
        toast("Success", {
          type: "success",
          position: "top-right",
        });
        refetch();
        setShowAddOvertimeModal(false);
        setSelected({
          ...result.overtime,
          newStatus: "Sent for Approval",
        });
        openApproval(true);
      } else {
        toast(result?.overtime, {
          type: "error",
          position: "top-right",
        });
      }
    } catch (error) {
      toast("Error unable to perform  action", {
        type: "error",
        position: "top-right",
      });
    }
  };

  const submit = async (e) => {
    e.preventDefault();
    // setLoading(true);
    await saveToAllowance();
    // setLoading(false);
  };

  const getAllowanceMoney = (bene, hours) => {
    let employee = employees.find((el) => el?.userId === state?.employeeId);
    let totalSum = 0;
    let sum = 0;
    let total = 0;
    let perDay = false;

    employee = {
      ...employee?.personalInfo,
      ...employee?.jobInfo,
      ...converArrayToObject(
        employee?.jobInfo?.usergrade?.custom,
        "value",
        "name",
        true
      ),
      ...employee?.jobInfo?.usergrade?.salary,
    };

    bene = {
      ...bene,
      ...converArrayToObject(bene["customSettings"], "status", "name"),
    };
    // eslint-disable-next-line no-unused-vars
    for (const key in bene) {
      // When its Percentage
      if (
        key !== "enabled" &&
        key !== "earned" &&
        bene["paymentType"] === "Percentage" &&
        bene[key] === true
      ) {
        sum += parseFloat(employee[key] ? employee[key] : 0);
      }

      // When is Static
      if (bene["paymentType"] === "Static") {
        total = bene.percentage;
      }
    }

    // Calculating total by Percentage
    if (bene["paymentType"] === "Percentage") {
      if (bene["calculatePer"] === "hour" || bene["calculatePer"] === "day") {
        total = ((bene.percentage / 100) * sum).toFixed(2);
        // total = total * hours; // if it is not fixed
        perDay = true;
        totalSum += parseFloat(total);
      } else {
        total = ((bene.percentage / 100) * sum).toFixed(2);
        totalSum += parseFloat(total);
      }
    }

    // Calculating total by Static Amount
    if (bene["paymentType"] === "Static") {
      if (bene["calculatePer"] === "hour" || bene["calculatePer"] === "day") {
        // total = total * hours;
        perDay = true;
        totalSum = parseFloat(total);
      } else {
        totalSum = parseFloat(total);
      }
    }

    // console.log(totalSum);

    return { totalSum, perDay };
  };

  const addMore = (e) => {
    e.preventDefault();

    var from = moment(
      moment(new Date(holdIt.overtimeDate)).format("YYYY-MM-DD"),
      "YYYY-MM-DD"
    );
    var to = moment(
      moment(new Date(holdIt.overtimeDateTo)).format("YYYY-MM-DD"),
      "YYYY-MM-DD"
    );
    var duration = moment.duration(to.diff(from));
    var days = duration.asDays() + 1;

    // const found = addedArray.find(
    //   (el) => el?.allowanceId === holdIt.allowanceId && el?.job === holdIt.job
    // );

    // if (found) {
    //   return toast("Already Added.", {
    //     type: "error",
    //     position: "top-right",
    //   });
    // }

    const selected = allowanceForSelectedUser?.find(
      (el) => el.value === holdIt.allowanceId
    );

    let total = 0;
    const { totalSum, perDay } = getAllowanceMoney(selected, days);

    if (useCustom) {
      if (perDay) {
        total = overTimeAmount * days;
      } else {
        total = overTimeAmount;
      }
    } else {
      if (perDay) {
        total = totalSum * days;
      } else {
        total = totalSum;
      }
    }

    setAddedArray((el) =>
      el.concat({
        overtimeDate: holdIt.overtimeDate,
        description: holdIt.description,
        allowanceId: holdIt.allowanceId,
        amount: total,
        // amount,
        name: allowanceForSelectedUser?.find(
          (item) => item?.value === holdIt.allowanceId
        )?.label,
        job: holdIt.job,
        tittle: holdIt.tittle,
        days,
        overtimeDateTo: holdIt.overtimeDateTo,
      })
    );
    setHoldIt({
      overtimeDate: new Date(),
      description: "",
      allowanceId: "",
      amount: 0,
      name: "",
      job: "",
      tittle: "",
      overtimeDateTo: new Date(),
      days: 0,
    });
  };

  const remove = (ind) => {
    // const remove = addedArray.filter(
    //   (el) => el?.allowanceId !== id && el?.job !== jobId
    // );
    const remove = addedArray.filter((el, index) => index !== ind);
    setAddedArray(remove);
  };

  const validationTo = (currentDate) => {
    if (holdIt.overtimeDate) {
      return currentDate.isAfter(
        moment(holdIt.overtimeDate, "DD MMM, YYYY").add(-1, "days")
      );
    }
  };

  const validationFrom = (currentDate) => {
    return currentDate.isBefore(
      moment(new Date(), "DD MMM, YYYY").add(0, "days")
    );
  };

  useEffect(() => {
    if (!useCustom) {
      setOverTimeAmount(0);
    }
  }, [useCustom]);

  return (
    <Modal
      className="modal custom-modal fade"
      show={true}
      centered
      onHide={() => setShowAddOvertimeModal(false)}
      size="lg"
    >
      <Modal.Header closeButton>
        <Modal.Title>Apply Allowance</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <form>
          <div className="row">
            <div className="d-flex col-6 mb-4">
              <label className="mx-3">Use Custom Amount</label>
              <div
                className="onoffswitch ml-0"
                onClick={(e) => {
                  setUseCustom(!useCustom);
                }}
              >
                <input
                  type="checkbox"
                  name="onoffswitch"
                  className="onoffswitch-checkbox"
                  checked={useCustom}
                />
                <label className="onoffswitch-label">
                  <span className="onoffswitch-inner"></span>
                  <span className="onoffswitch-switch"></span>
                </label>
              </div>
            </div>

            <div className="d-flex align-items-baseline col-6 mb-4">
              <label>Amount</label>

              <CurrencyInput
                className="form-control mx-4"
                value={overTimeAmount}
                onValueChange={(value, name) => {
                  setOverTimeAmount(value);
                }}
              />
            </div>

            <div className="form-group col-6" style={{ zIndex: "100" }}>
              <label>
                Select Employee <span className="text-danger">*</span>
              </label>
              {mapEmployees && (
                <Select
                  key={state.employeeId}
                  closeMenuOnSelect={true}
                  isSearchable
                  required
                  classNamePrefix="form-control"
                  value={mapEmployees?.find(
                    (el) => el.value === state.employeeId
                  )}
                  onChange={(selected) => {
                    setState({
                      ...state,
                      employeeId: selected?.value || "",
                    });
                    selected?.value && getAllowanceForUser(selected?.value);
                  }}
                  options={mapEmployees}
                  isClearable
                />
              )}
            </div>

            <div className="form-group col-6">
              <label>
                Allowance <span className="text-danger">*</span>
              </label>
              <Select
                key={holdIt.allowanceId}
                closeMenuOnSelect={true}
                isSearchable
                required
                classNamePrefix="form-control"
                value={allowanceForSelectedUser?.find(
                  (el) => el.value === holdIt.allowanceId
                )}
                onChange={(selected) => {
                  setHoldIt({
                    ...holdIt,
                    allowanceId: selected?.value || "",
                  });
                }}
                options={allowanceForSelectedUser}
                isClearable
                isDisabled={state?.employeeId === ""}
              />
            </div>
          </div>

          <div className="row">
            <div className="form-group col-6">
              <label>
                From Date <span className="text-danger">*</span>
              </label>
              <div className="cal-icon">
                <DatePicker
                  value={holdIt.overtimeDate}
                  dateFormat="DD MMM, YYYY"
                  onChange={(date) => {
                    setHoldIt({
                      ...holdIt,
                      overtimeDate: date,
                      overtimeDateTo: date,
                    });
                  }}
                  closeOnSelect={true}
                  timeFormat={false}
                  required={true}
                  isValidDate={validationFrom}
                />
              </div>
            </div>
            <div className="form-group col-6">
              <label>
                To Date <span className="text-danger">*</span>
              </label>
              <div className="cal-icon">
                <DatePicker
                  value={holdIt.overtimeDateTo}
                  dateFormat="DD MMM, YYYY"
                  onChange={(date) => {
                    setHoldIt({
                      ...holdIt,
                      overtimeDateTo: date,
                    });
                  }}
                  closeOnSelect={true}
                  timeFormat={false}
                  isValidDate={validationTo}
                />
              </div>
            </div>
            {/* //o: new Date(), */}
          </div>
          <div className="row">
            <div className="form-group col-6" style={{ zIndex: "99" }}>
              <label>
                Job <span className="text-danger">*</span>
              </label>
              <Select
                key={holdIt.job}
                closeMenuOnSelect={true}
                isSearchable
                required
                classNamePrefix="form-control"
                value={jobs?.find((el) => el.value === holdIt.job)}
                onChange={(selected) => {
                  setHoldIt({
                    ...holdIt,
                    job: selected?.value || "",
                    tittle: selected?.label || "",
                  });
                }}
                options={jobs}
                isClearable
                isDisabled={
                  state?.employeeId === "" ||
                  holdIt.allowanceId === "" ||
                  holdIt.overtimeDate === "" ||
                  holdIt.overtimeDateTo === ""
                }
              />
            </div>
            <div className="form-group col-6">
              <label>Job Done</label>
              <textarea
                rows="2"
                className="form-control"
                onChange={(e) => {
                  setHoldIt({
                    ...holdIt,
                    description: e.target.value,
                  });
                }}
                value={holdIt.description}
              ></textarea>
            </div>
          </div>
          <div className="d-flex justify-content-end">
            <button
              disabled={holdIt.allowanceId === "" || holdIt.job === ""}
              onClick={addMore}
              className="btn btn-primary mb-3"
            >
              Add
            </button>
          </div>

          {addedArray?.length > 0 ? (
            <Table
              striped="true"
              responsive
              sticky="true"
              className="product-table text-nowrap"
            >
              <thead>
                <tr>
                  <th>Allowance</th>
                  <th>Job</th>
                  <th>From</th>
                  <th>To</th>
                  <th>Days</th>
                  <th>Amount</th>
                  <th>Job Done</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                {addedArray?.map((el, i) => (
                  <tr key={i}>
                    <td>{el?.name}</td>
                    <td>{el?.tittle}</td>
                    <td>
                      {moment(new Date(el?.overtimeDate)).format(
                        "MMMM DD yyyy"
                      )}
                    </td>
                    <td>
                      {moment(new Date(el?.overtimeDateTo)).format(
                        "MMMM DD yyyy"
                      )}
                    </td>
                    <td>{el?.days}</td>
                    <td>
                      {currency(el?.amount, {
                        symbol: "",
                      }).format()}
                    </td>
                    <td>{el?.description}</td>
                    <td>
                      <p className="p-cursor" onClick={() => remove(i)}>
                        {DisapprovedCheckIcon()}
                      </p>
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          ) : null}

          <div className="summaryNew border-top">
            <div
              className="gridCont three-col-grid"
              style={{ gridTemplateRows: "unset" }}
            >
              <div></div>
              <div></div>
              <div className="gridChild gridChildBorderLeftDarkerGreen">
                <div className="gridChildLeft">
                  <p className="gridChld1">
                    {currency(state.total, {
                      symbol: "",
                    }).format()}
                  </p>
                  <p className="gridChld2">Total Allowance </p>
                </div>
              </div>
            </div>
          </div>
          <div className="submit-section">
            <button
              onClick={submit}
              className="btn btn-primary submit-btn"
              disabled={loading || addedArray?.length < 1}
            >
              {loading ? "Please wait..." : "Submit"}
            </button>
          </div>
        </form>
      </Modal.Body>
    </Modal>
  );
}
